import React from 'react';
import styled from '@emotion/styled';
import { STICKY_ROOT } from 'consts/rootNodes';
import { createPortal } from 'utils/universalPortal';
import PrivateBulletinBar from './PrivateBulletinBar';
import { IBulletin, ICommercialBulletin } from 'utils/entities';

const Root = styled.div({
  position: 'fixed',
  bottom: 0,
  left: 0,
  right: 0,
  zIndex: 13,
  willChange: 'transform',
  transform: 'translateY(100%)',
  animation: '.2s linear 1s forwards slideUp',
  '@keyframes slideUp': {
    from: {
      transform: 'translateY(100%)',
    },
    to: {
      transform: 'translateY(0)',
    },
  },
});

interface PrivateBulletinStickyBarProps {
  bulletin: IBulletin | ICommercialBulletin;
}

const PrivateBulletinStickyBar: React.FC<PrivateBulletinStickyBarProps> = props => {
  const { bulletin } = props;
  return createPortal(
    <Root data-auto="private-bulletin-sticky-bar">
      <PrivateBulletinBar
        bulletin={bulletin}
      />
    </Root>,
    STICKY_ROOT
  );
};

export default PrivateBulletinStickyBar;
